document.addEventListener('DOMContentLoaded', function () {
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileMenuOpenBtn = document.querySelector('[data-mobile-menu-open]');

  if (mobileMenu && mobileMenuOpenBtn) {
    var openMobileMenu = function () {
      mobileMenu.classList.add('is-open');
      mobileMenuOpenBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mobile-menu-open');
    };
    var closeMobileMenu = function () {
      mobileMenu.classList.remove('is-open');
      mobileMenuOpenBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mobile-menu-open');
    };
    mobileMenuOpenBtn.addEventListener('click', openMobileMenu);
    mobileMenu.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMobileMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobileMenu();
    });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPopover = document.querySelector('[data-search-popover]');

  if (searchToggle && searchPopover) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchPopover.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var input = searchPopover.querySelector('input[type=search]');
        if (input) input.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!searchPopover.contains(e.target) && e.target !== searchToggle && !searchToggle.contains(e.target)) {
        searchPopover.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
